<template lang="pug">
  div.analytic.report-revegetation
    e-form-modal(
    ref="modalForm"
    @submitModalForm="submitModal()"
    :hideDeleteButton="false"
    :saveBtnLabel="nextBtnTitle"
    savingBtnLabel="Скачивание"
    )
      div(slot="header")
        h1.title {{currentConfig.title}}
        div.subtitle
          h3(v-show="tabView === 'step1'") Общие данные об организации
          h3(v-show="tabView === 'step2'") Раздел I. Нарушение и рекультивация земель
          h3(v-show="tabView === 'step3'") Раздел II. Снятие и использование плодородного слоя почвы
      slot
        e-form(:formValidator="formValidator")
          div(v-if="tabView === 'step1'")
            div.body
              div.col
                e-form-subtitle(text="Сведения об организации")

                e-form-group(
                name="year"
                inputType="select"
                label="Год"
                :model="fields"
                tabView="step1"
                :options="years"
                )

                e-form-group(
                label="Полное наименование организации"
                name="org_name"
                :model="fields"
                :suggestionEndpoint="suggestionEndpoint"
                :transformSuggestions="transformSuggestions"
                @selectItem="selectItem"
                :suggestDelay="0"
                :minSuggestLen="2"
                :useInnerSearch="false"
                inputType="suggestion"
                tabView="step1"
                :required="true"
                placeholder="Начните вводить название регионального оператора..."
                )

                e-form-group(
                name="org_short_name"
                inputType="input"
                label="Кратное наименование организации"
                :model="fields"
                tabView="step1"
                )

                e-form-group(
                name="post_index"
                inputType="input"
                label="Индекс"
                :model="fields"
                validatioRule="number"
                tabView="step1"
                )

                e-form-group(
                name="address"
                inputType="input"
                label="Фактический адрес"
                :model="fields"
                tabView="step1"
                )

                e-form-group(
                name="okpo"
                inputType="input"
                label="ОКПО"
                :model="fields"
                tabView="step1"
                validatioRule="number"
                )

                e-form-group(
                name="report_date"
                inputType="calendar"
                label="Дата составления документа"
                :model="fields"
                tabView="step1"
                :required="true"
                )


              div.col
                e-form-subtitle(text="Должностное лицо, ответственное за предоставление статистической информации")

                e-form-group(
                name="person_name"
                inputType="input"
                label="ФИО"
                :model="fields"
                tabView="step1"
                :required="true"
                )

                e-form-group(
                name="person_phone"
                inputType="input"
                label="Номер телефона"
                :model="fields"
                tabView="step1"
                )

                e-form-group(
                name="person_position"
                inputType="input"
                label="Должность"
                :model="fields"
                tabView="step1"
                )

          div(v-if="tabView === 'step2'").step2
            div.body
              div.col
                br
                e-perfect-scrollbar(
                :config="{suppressScrollY: false, suppressScrollX: false}"
                ).table-scrollbar
                  div.table
                    table
                      thead
                        th №
                        th Наименование показателя
                        th(
                        v-for="fieldName, i in INDICATOR_COLS_ORDER"
                        :key="i"
                        ) {{INDICATOR_COLS_TITLE[fieldName]}}
                      tbody
                        tr
                          td(
                          colspan="100"
                          ) Наличие нарушенных земель на начало отчетного периода
                            p(
                            v-if="SHOW_HIDDEN_FIELDS"
                            ) {{fields.indicators}}
                        tr(
                        v-for="indicatorId in PERIOD_INDICATORS_ORDER"
                        :key="indicatorId"
                        )
                          td {{indicatorId}}
                          td {{INDICATOR_ROWS_TITLE[indicatorId]}}
                          td(
                          v-for="fieldName, i in INDICATOR_COLS_ORDER"
                          :key="`fields.indicators.${indicatorId}.${fieldName}`"
                          )
                            e-form-group(
                            @input="calcSectionOne"
                            :required="true"
                            :model="fields.indicators[indicatorId]"
                            :name="fieldName"
                            validationRule="double"
                            tabView="step2"
                            :validateAlias="`fields.indicators.${indicatorId}.${fieldName}`"
                            :disabled="isIndicatorFieldDisabled(indicatorId, fieldName)"
                            )
                        tr
                          td(
                          colspan="100"
                          )  За отчетный год
                        tr(
                        v-for="indicatorId in YEAR_INDICATORS_ORDER"
                        :key="indicatorId"
                        )
                          td {{indicatorId}}
                          td {{INDICATOR_ROWS_TITLE[indicatorId]}}
                          td(
                          v-for="fieldName, i in INDICATOR_COLS_ORDER"
                          :key="`fields.indicators.${indicatorId}.${fieldName}`"
                          )
                            e-form-group(
                            @input="calcSectionOne"
                            :model="fields.indicators[indicatorId]"
                            :name="fieldName"
                            validationRule="double"
                            tabView="step2"
                            :validateAlias="`fields.indicators.${indicatorId}.${fieldName}`"
                            :disabled="isIndicatorFieldDisabled(indicatorId, fieldName)"
                            )
                        tr
                          td(
                          colspan="100"
                          )  Наличие нарушенных земель на начало отчетного года
                        tr(
                        v-for="indicatorId in YEAR_START_INDICATORS_ORDER"
                        :key="indicatorId"
                        )
                          td {{indicatorId}}
                          td {{INDICATOR_ROWS_TITLE[indicatorId]}}
                          td(
                          v-for="fieldName, i in INDICATOR_COLS_ORDER"
                          :key="`fields.indicators.${indicatorId}.${fieldName}`"
                          )
                            e-form-group(
                            @input="calcSectionOne"
                            :model="fields.indicators[indicatorId]"
                            :name="fieldName"
                            validationRule="double"
                            tabView="step2"
                            :validateAlias="`fields.indicators.${indicatorId}.${fieldName}`"
                            :disabled="isIndicatorFieldDisabled(indicatorId, fieldName)"
                            )

          div(v-if="tabView === 'step3'")
            div.body
              div.col
                br
                div.table
                  table
                    thead
                      th №
                      th Наименование показателя
                      th Единица измерения
                      th Всего
                    tbody
                      tr(
                      v-for="row, i in THIRD_SECTION_TABLE"
                      :key="i"
                      )
                        td {{row.n}}
                        td {{row.t}}
                        td {{row.u}}
                        td
                          e-form-group(
                          :model="fields"
                          :name="row.f"
                          validationRule="double"
                          tabView="step3"
                          @input="calcSectionSecond"
                          )

            div.body
              div.col
                e-form-group(
                name="additional_info"
                inputType="textarea"
                label="Пояснительная записка"
                :model="fields"
                tabView="step3"
                )

      div(slot="footer").actions-filter-panel.actions-filter-panel--right
        div
          button(
          v-if="showPrevBtn"
          type="button"
          :disabled="freezeAllEvents"
          @click="navigateByStep(-1)"
          ).actions-filter-panel__button.standart.standart-noborder Назад
          button(
          v-else
          type="button"
          :disabled="freezeAllEvents"
          @click="closeModal()"
          ).actions-filter-panel__button.standart.standart-noborder Отмена
          button(
          type="button"
          :disabled="freezeAllEvents"
          @click="submitModal()"
          v-if="userCanCreate"
          ).actions-filter-panel__button.standart {{nextBtnTitle}}
</template>

<script>
  import reportDownloadMixin from './mixins/report-download-mixin'
  import {REPORT_NAME} from "./utils/types"
  import yearHelper from '../../utils/year'
  import {report, tko} from "../../api/api-endpoints"
  import saveFile from '../../utils/saveFile'
  import {SHOW_HIDDEN_FIELDS} from "../../config/config"

  const PRECISION = 3

  const IndicatorModel = () => ({
    "total": 0,
    "extraction": 0,
    "transit_leak": 0,
    "build": 0,
    "ameliorative": 0,
    "tree_fell": 0,
    "research": 0,
    "placement": 0,
    "other": 0
  })

  const INDICATOR_ROWS = {
    StartReportPeriodAll: 1,
    StartReportPeriodWorked: 2,
    DisturbedAll: 3,
    Worked: 4,
    Revegatated: 5,
    LandArable: 6,
    LandOther: 7,
    LandTrees: 8,
    LandWater: 9,
    StartReportYearAll: 10,
    StartReportYearWorked: 11
  }

  const INDICATOR_ROWS_TITLE = {
    [INDICATOR_ROWS.StartReportPeriodAll]: 'всего',
    [INDICATOR_ROWS.StartReportPeriodWorked]: 'в том числе отработано',
    [INDICATOR_ROWS.DisturbedAll]: 'Нарушено земель - всего',
    [INDICATOR_ROWS.Worked]: 'Отработано из общей площади нарушенных земель',
    [INDICATOR_ROWS.Revegatated]: 'Рекультивировано земель - всего',
    [INDICATOR_ROWS.LandArable]: 'пашню',
    [INDICATOR_ROWS.LandOther]: 'другие сельскохозяйственные угодья',
    [INDICATOR_ROWS.LandTrees]: 'лесные насаждения',
    [INDICATOR_ROWS.LandWater]: 'водоемы и другие цели',
    [INDICATOR_ROWS.StartReportYearAll]: 'всего',
    [INDICATOR_ROWS.StartReportYearWorked]: 'в том числе отработано'
  }

  const PERIOD_INDICATORS_ORDER = [
    INDICATOR_ROWS.StartReportPeriodAll,
    INDICATOR_ROWS.StartReportPeriodWorked
  ]

  const YEAR_INDICATORS_ORDER = [
    INDICATOR_ROWS.DisturbedAll,
    INDICATOR_ROWS.Worked,
    INDICATOR_ROWS.Revegatated, // 5
    INDICATOR_ROWS.LandArable, // 6
    INDICATOR_ROWS.LandOther, // 7
    INDICATOR_ROWS.LandTrees, // 8
    INDICATOR_ROWS.LandWater // 9
  ]

  const YEAR_START_INDICATORS_ORDER = [
    INDICATOR_ROWS.StartReportYearAll,
    INDICATOR_ROWS.StartReportYearWorked
  ]

  const INDICATOR_COLS_TITLE = {
    total: 'Всего, га',
    extraction: 'при разработке месторождений полезных ископаемых (включая общераспространенные полезные ископаемые)',
    transit_leak: 'вследствие утечки при транзите нефти, газа, продуктов переработки нефти',
    build: 'при строительных работах',
    ameliorative: 'при мелиоративных работах',
    tree_fell: 'при лесозаготовительных работах',
    research: 'при изыскательских работах',
    placement: 'при размещении промышленных (в том числе строительных) и твердых бытовых отходов',
    other: 'при иных работах'
  }

  const INDICATOR_COLS_ORDER = [
    'total',
    'extraction',
    'transit_leak',
    'build',
    'ameliorative',
    'tree_fell',
    'research',
    'placement',
    'other'
  ]

  const DISABLE_EDIT_IN_INDICATOR_FOR_FIELDS = {
    [INDICATOR_ROWS.StartReportPeriodAll]: ['total'],
    [INDICATOR_ROWS.StartReportPeriodWorked]: ['total'],
    [INDICATOR_ROWS.DisturbedAll]: ['total'],
    [INDICATOR_ROWS.Worked]: ['total'],
    [INDICATOR_ROWS.Revegatated]: INDICATOR_COLS_ORDER,
    [INDICATOR_ROWS.LandArable]: ['total'],
    [INDICATOR_ROWS.LandOther]: ['total'],
    [INDICATOR_ROWS.LandTrees]: ['total'],
    [INDICATOR_ROWS.LandWater]: ['total'],
    [INDICATOR_ROWS.StartReportYearAll]: INDICATOR_COLS_ORDER,
    [INDICATOR_ROWS.StartReportYearWorked]: INDICATOR_COLS_ORDER
  }

  const THIRD_SECTION_TABLE = [
    {
      n: 12,
      t: 'Наличие заскладированного плодородного слоя почвы на начало отчетного года - всего',
      u: 'тыс м3',
      f: 'ground_stored'
    },
    {
      n: 13,
      t: 'За отчетный Год. Снято плодородного слоя почвы: площадь',
      u: 'га',
      f: 'ground_removed_area'
    },
    {
      n: 14,
      t: 'Объем',
      u: 'тыс м3',
      f: 'ground_removed_size'
    },
    {
      n: 15,
      t: 'Использовано плодородного слоя почвы',
      u: 'тыс м3',
      f: 'ground_used'
    },
    {
      n: 16,
      t: 'в том числе на: рекультивацию земель',
      u: 'тыс м3',
      f: 'ground_used_remediation'
    },
    {
      n: 17,
      t: 'улучшение малопродуктивных угодий',
      u: 'тыс м3',
      f: 'ground_used_improve'
    },
    {
      n: 18,
      t: 'другие цели',
      u: 'тыс м3',
      f: 'ground_used_other'
    },
    {
      n: 19,
      t: 'Улучшено малопродуктивных угодий снятым плодородным слоем почвы',
      u: 'га',
      f: 'improved_ground'
    },
    {
      n: 20,
      t: 'Наличие заскладированного плодородного слоя почвы на начало отчетного года - всего',
      u: 'тыс м3',
      f: 'ground_stored_next_year'
    }
  ]

  export default {
    name: 'report-revegetation',
    mixins: [reportDownloadMixin],
    data () {
      return {
        fields: {
          year: yearHelper.getCurrentYear(),
          operator_id: '',
          org_name: '',
          org_short_name: '',
          post_index: '',
          address: '',
          okpo: '',
          report_date: '',
          person_name: '',
          person_phone: '',
          person_position: '',
          additional_info: '',
          indicators: {
            [INDICATOR_ROWS.StartReportPeriodAll]: new IndicatorModel(),
            [INDICATOR_ROWS.StartReportPeriodWorked]: new IndicatorModel(),
            [INDICATOR_ROWS.DisturbedAll]: new IndicatorModel(),
            [INDICATOR_ROWS.Worked]: new IndicatorModel(),
            [INDICATOR_ROWS.Revegatated]: new IndicatorModel(),
            [INDICATOR_ROWS.LandArable]: new IndicatorModel(),
            [INDICATOR_ROWS.LandOther]: new IndicatorModel(),
            [INDICATOR_ROWS.LandTrees]: new IndicatorModel(),
            [INDICATOR_ROWS.LandWater]: new IndicatorModel(),
            [INDICATOR_ROWS.StartReportYearAll]: new IndicatorModel(),
            [INDICATOR_ROWS.StartReportYearWorked]: new IndicatorModel()
          },
          ground_stored: 0,
          ground_removed_area: 0,
          ground_removed_size: 0,
          ground_used: 0,
          ground_used_remediation: 0,
          ground_used_improve: 0,
          ground_used_other: 0,
          improved_ground: 0,
          ground_stored_next_year: 0
        },
        tabView: 'step1'
      }
    },
    computed: {
      SHOW_HIDDEN_FIELDS () {
        return SHOW_HIDDEN_FIELDS
      },
      THIRD_SECTION_TABLE () {
        return THIRD_SECTION_TABLE
      },
      YEAR_START_INDICATORS_ORDER () {
        return YEAR_START_INDICATORS_ORDER
      },
      YEAR_INDICATORS_ORDER () {
        return YEAR_INDICATORS_ORDER
      },
      PERIOD_INDICATORS_ORDER () {
        return PERIOD_INDICATORS_ORDER
      },
      INDICATOR_COLS_TITLE () {
        return INDICATOR_COLS_TITLE
      },
      INDICATOR_COLS_ORDER () {
        return INDICATOR_COLS_ORDER
      },
      INDICATOR_ROWS_TITLE () {
        return INDICATOR_ROWS_TITLE
      },
      steps () {
        return ['step1', 'step2', 'step3']
      },
      showPrevBtn () {
        return this.currentStepIdx > 0
      },
      nextBtnTitle () {
        if (this.tabView !== 'step3') {
          return 'Дальше'
        }
        return 'Скачать'
      },
      years () {
        return yearHelper.getSpecifiedYearsOptions(2017, 2050, false)
      },
      reportId () {
        return REPORT_NAME.TP2Revegetation
      },
      currentStepIdx () {
        return this.steps.findIndex(v => v == this.tabView)
      }
    },
    methods: {
      isIndicatorFieldDisabled (indicatorId, fieldName) {
        return DISABLE_EDIT_IN_INDICATOR_FOR_FIELDS[indicatorId] && DISABLE_EDIT_IN_INDICATOR_FOR_FIELDS[indicatorId].indexOf(fieldName) > -1
      },
      // https://redmine.etton.ru/issues/13633
      calcSectionSecond () {
        console.warn('calcSectionSecond')
        // Строка 15 = стр. 16 + стр. 17 + стр. 18
        let used = +this.fields.ground_used_remediation + +this.fields.ground_used_improve + +this.fields.ground_used_other
        if (isNaN(used)) {
          used = 0
        }
        this.$set(this.fields, 'ground_used', used)
        // Строка 20 = стр. 12 + стр. 14 - стр. 15
        let stored = +this.fields.ground_stored + +this.fields.ground_removed_size - +this.fields.ground_used
        if (isNaN(stored)) {
          stored = 0
        }
        this.$set(this.fields, 'ground_stored_next_year', stored)
      },
      calcSectionOne () {
        console.warn('calcSectionOne')
        this.calcRevegationByCols()
        this.calcTotalByColsWithExpr()
        this.calcWorkedByColsWithExpr()
        this.caclTotalFromEveryRows()
      },
      /**
       * Строка 11 = стр. 02 + стр. 04 – стр. 05 по всем столбцам
       */
      calcWorkedByColsWithExpr () {
        let res = 0
        const model = new IndicatorModel()
        for (let fieldName in model) {
          res = 0
          let str2 = +this.fields.indicators[INDICATOR_ROWS.StartReportPeriodWorked][fieldName]
          let str4 = +this.fields.indicators[INDICATOR_ROWS.Worked][fieldName]
          let str5 = +this.fields.indicators[INDICATOR_ROWS.Revegatated][fieldName]
          res = +str2 + str4 - str5
          if (isNaN(res)) {
            res = 0
          }
          this.$set(this.fields.indicators[INDICATOR_ROWS.StartReportYearWorked], fieldName, res.toFixed(PRECISION))
        }
      },
      /**
       * Строка 10 = стр. 01 + стр. 03 – стр. 05 по всем столбцам
       *
       */
      calcTotalByColsWithExpr () {
        let res = 0
        const model = new IndicatorModel()
        for (let fieldName in model) {
          res = 0
          let str1 = +this.fields.indicators[INDICATOR_ROWS.StartReportPeriodAll][fieldName]
          let str3 = +this.fields.indicators[INDICATOR_ROWS.DisturbedAll][fieldName]
          let str5 = +this.fields.indicators[INDICATOR_ROWS.Revegatated][fieldName]
          res = +str1 + str3 - str5
          if (isNaN(res)) {
            res = 0
          }
          this.$set(this.fields.indicators[INDICATOR_ROWS.StartReportYearAll], fieldName, res.toFixed(PRECISION))
        }
      },
      /**
       * Строка 5 = стр. 6 + стр.7 + стр.8 + стр. 9 по всем столбцам
       */
      calcRevegationByCols () {
        let sum = 0
        let val = 0
        const summRows = [
          INDICATOR_ROWS.LandArable,
          INDICATOR_ROWS.LandOther,
          INDICATOR_ROWS.LandTrees,
          INDICATOR_ROWS.LandWater
        ]
        const model = new IndicatorModel()
        for (let fieldName in model) {
          sum = 0
          summRows.forEach(indicatorId => {
            val = +this.fields.indicators[indicatorId][fieldName]
            if (!isNaN(val)) {
              sum = +sum + val
            }
          })
          this.$set(this.fields.indicators[INDICATOR_ROWS.Revegatated], fieldName, sum.toFixed(PRECISION))
        }
      },
      /**
       * Столбец "Всего, га" заполняется Суммой по всей строке.
       */
      caclTotalFromEveryRows () {
        let sum = 0
        let val = 0
        for (let indicatorId in this.fields.indicators) {
          sum = 0
          for (let fieldName in this.fields.indicators[indicatorId]) {
            if (fieldName !== 'total') {
              val = +this.fields.indicators[indicatorId][fieldName]
              if (!isNaN(val)) {
                sum = +sum + val
              }
            }
          }
          this.$set(this.fields.indicators[indicatorId], 'total', sum.toFixed(PRECISION))
        }
      },
      selectItem ($event) {
        if ($event && $event.id) {
          let copy = JSON.parse(JSON.stringify($event))
          let names = copy.name.split('<br>')
          this.fields.operator_id = copy.id
          this.fields.address = copy.fact_address
          this.fields.org_name = names.join(', ')
          this.fields.org_short_name = names[0]
        } else {
          this.fields.operator_id = ''
          this.fields.address = ''
          this.fields.org_name = ''
          this.fields.org_short_name = ''
        }
      },
      transformSuggestions (ctx, data) {
        return data.data
      },
      suggestionEndpoint (ctx, q) {
        let route = {query: {q, 'per-page': 50}}
        return tko.regionalOperators(route)
      },
      navigateByStep (val) {
        this.tabView = this.steps[this.currentStepIdx + val] + ''
      },
      submitModal () {
        let {hasError} = this.formValidator.validate(this)
        if (!hasError) {
          if (this.currentStepIdx === -1) {
            let err = new Error('Неизвестный шаг')
            console.error(err)
            this.$e.errorBox(err)
          } else if (this.steps[this.currentStepIdx + 1]) {
            this.navigateByStep(1)
          } else {
            this.startDownload()
          }
        }
      },
      startDownload () {
        if (!this.userCanCreate) {
          return
        }

        this.freezeAllEvents = true
        this.$bar.start()
        this.$store.dispatch('downloadFile', {
          endpoint: report.remediation(),
          reqMethod: 'post',
          data: this.fields
        }).then(r => {
          this.$bar.finish()
          console.log(r)
          let blob = r.request.response
          let fileName = `${new Date()}.xlsx`
          saveFile({blob, fileName, headers: r.headers})
          // close small modal after download
          // set delay for more user friendly
          /* setTimeout(() => {
            this.freezeAllEvents = false
            this.closeModal()
          }, 300) */
        }).catch(erResponse => {
          this.freezeAllEvents = false
          this.$bar.finish()
          if (erResponse && +erResponse.status === 422) {
            let {notFoundedErrorFieldsText} = this.formValidator.handleServerErrors(erResponse, this)
            if (notFoundedErrorFieldsText) {
              this.$e.errorBox(
                'Некорректно заполнены поля',
                {text: notFoundedErrorFieldsText}
              )
            }
          } else {
            this.$e.errorBox(erResponse)
          }
        })
      }
    },
    asyncData () {
      return Promise.resolve(true)
    }
  }
</script>
